import { DapSpreadsheetType } from '@/modules/dap/enums';
import {
  DapSpreadsheetConsolidated,
  DapSpreadsheetInfluencePlan,
  DapSpreadsheetMarketShareInfluence,
  DapSpreadsheetSegmentInfluence,
  DapSpreadsheetStores,
  DapSpreadsheetByAov,
  DapSpreadsheetByMarkedArea,
  SpreadsheetComposer
} from '@/modules/dap/services/dap-spreadsheet';
import {
  DapSpreadsheetAprovationFlow,
  DapSpreadsheetAprovationFlowRetail
} from '@/modules/dap/services/dap-spreadsheet-flow';
import * as _ from 'lodash';
import { DapSpreadsheetInfo } from './dap-spreadsheet';
import { DapSpreadsheetAprovationFlowRetailConsolidate } from './dap-spreadsheet-flow/dap-spreadsheet-aprovation-flow-retail-consolidate';

export class DapSpreadsheetFactory {
  static get(type: DapSpreadsheetType, dataSource: any[]) {
    let dataSourceGroup: any;
    let dapInfluencePlan: any;
    let dapMarketShareInfluence: any;
    let dapSegmentInfluence: any;
    let dapInfo: any;
    let dapSumByAov: any;
    let dapSumByMarkedArea: any;
    let spreadsheetComposer: SpreadsheetComposer;

    switch (type) {
      case DapSpreadsheetType.Stores:
        return new DapSpreadsheetStores().mount(dataSource);
      case DapSpreadsheetType.InfluencePlan:
        return new DapSpreadsheetInfluencePlan().mount(dataSource);
      case DapSpreadsheetType.MarketShareInfluence:
        return new DapSpreadsheetMarketShareInfluence().mount(dataSource);
      case DapSpreadsheetType.SegmentInfluence:
        return new DapSpreadsheetSegmentInfluence().mount(dataSource);
      case DapSpreadsheetType.SummaryByAov:
        return new DapSpreadsheetByAov().mount(dataSource);
      case DapSpreadsheetType.AprovationFlow:
        return new DapSpreadsheetAprovationFlow().mount(dataSource);
      case DapSpreadsheetType.AprovationFlowRetail:
        return new DapSpreadsheetAprovationFlowRetail().mount(dataSource);
      case DapSpreadsheetType.AprovationFlowRetailConsolidate:
        return new DapSpreadsheetAprovationFlowRetailConsolidate().mount(dataSource);
      case DapSpreadsheetType.MarketShareAndSegmentInfluence:
        spreadsheetComposer = new SpreadsheetComposer('market_share_and_segment_influence');

        dataSourceGroup = _(dataSource[1])
          .groupBy(d => d.familyName)
          .value();

        spreadsheetComposer.name = `dap_${_.map(dataSourceGroup, (val: any, key: string) => key.toLowerCase()).join(
          '_'
        )}_${spreadsheetComposer.name}`;

        dapInfo = new DapSpreadsheetInfo().mount(dataSource[0]).workbookOptions.sheets;
        dapMarketShareInfluence = new DapSpreadsheetMarketShareInfluence().mount(dataSource[1]).workbookOptions.sheets;
        dapSegmentInfluence = new DapSpreadsheetSegmentInfluence().mount(dataSource[2]).workbookOptions.sheets;
        dapSumByAov = new DapSpreadsheetByAov().mount(dataSource[3]).workbookOptions.sheets;
        dapSumByMarkedArea = new DapSpreadsheetByMarkedArea().mount(dataSource[4]).workbookOptions.sheets;

        return spreadsheetComposer.mount([
          ...dapInfo,
          ...dapSumByAov,
          ...dapSumByMarkedArea,
          ...dapMarketShareInfluence,
          ...dapSegmentInfluence
        ]);
      case DapSpreadsheetType.AllMethodology:
        spreadsheetComposer = new SpreadsheetComposer('influence_plan');

        dapInfo = new DapSpreadsheetInfo().mount(dataSource[0]).workbookOptions.sheets;
        dapInfluencePlan = new DapSpreadsheetInfluencePlan().mount(dataSource[1][0]).workbookOptions.sheets;
        dapMarketShareInfluence = _.map(
          dataSource[2],
          (d: any) => new DapSpreadsheetMarketShareInfluence().mount(d).workbookOptions.sheets
        );
        dapSegmentInfluence = _.map(
          dataSource[3],
          (d: any) => new DapSpreadsheetSegmentInfluence().mount(d).workbookOptions.sheets
        );
        dapSumByAov = _.map(dataSource[4], (d: any) => new DapSpreadsheetByAov().mount(d).workbookOptions.sheets);
        dapSumByMarkedArea = _.map(
          dataSource[5],
          (d: any) => new DapSpreadsheetByMarkedArea().mount(d).workbookOptions.sheets
        );

        return spreadsheetComposer.mount(
          _.flatten([
            dapInfo,
            ...dapSumByAov,
            ...dapSumByMarkedArea,
            dapInfluencePlan,
            ...dapMarketShareInfluence,
            ...dapSegmentInfluence
          ])
        );
      case DapSpreadsheetType.Consolidated:
        return new DapSpreadsheetConsolidated().mount(dataSource);
      case DapSpreadsheetType.Info:
        return new DapSpreadsheetInfo().mount(dataSource);
      default:
        throw new Error('Unknown type');
    }
  }
}
